export const SET_LOCALES = "SET_LOCALES";

export const setLocales = (locales = 'en') => {
    return {
        type: SET_LOCALES,
        payload: {
            locales,
        },
    };
};